import { IconProps } from '../icon';

export function PlanningIcon(props: IconProps) {
  return (
    <svg
      fill="#000000"
      height="800px"
      width="800px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 490 490"
      xmlSpace="preserve"
      {...props}
    >
      <g>
        <g>
          <g>
            <path
              d="M418.248,71.752C371.977,25.482,310.45,0,245,0C179.551,0,118.025,25.482,71.754,71.752C25.483,118.022,0,179.55,0,245
				s25.483,126.978,71.754,173.248C118.025,464.518,179.551,490,245,490c65.45,0,126.977-25.482,173.248-71.752
				C464.518,371.978,490,310.45,490,245S464.518,118.022,418.248,71.752z M404.105,404.105C361.613,446.599,305.108,470,245,470
				c-60.106,0-116.611-23.401-159.104-65.895C43.402,361.612,20,305.107,20,245S43.402,128.388,85.896,85.895
				C128.389,43.401,184.894,20,245,20c60.108,0,116.613,23.401,159.105,65.895C446.598,128.387,470,184.892,470,245
				C470,305.108,446.598,361.613,404.105,404.105z"
            />
            <path
              d="M245,40c-28.99,0-57.004,5.923-83.265,17.604c-25.381,11.29-47.875,27.37-66.851,47.788
				C59.492,143.398,40,192.979,40,245c0,53.444,20.427,103.966,57.495,142.235c18.881,19.629,41.081,35.067,65.983,45.887
				C189.254,444.321,216.682,450,245,450c54.776,0,106.262-21.318,144.971-60.028C428.682,351.262,450,299.776,450,245
				C450,131.963,358.038,40,245,40z M382.708,368.565l-35.637-35.637l-14.143,14.143l35.637,35.637
				c-31.516,28.346-71.212,44.781-113.565,47.02V380h-20v49.731c-43.628-2.295-84.231-19.59-116.112-49.477l33.183-33.184
				l-14.143-14.141l-32.913,32.912C78.093,334.834,62.46,296.11,60.274,255H110v-20H60.277
				c2.128-39.816,16.933-77.588,42.396-108.184l35.256,35.255l14.142-14.143l-35.805-35.801
				c15.639-15.194,33.629-27.368,53.597-36.25c20.655-9.188,42.523-14.423,65.137-15.613V110h20V60.272
				c44.742,2.396,85.306,20.766,116.094,49.491l-38.165,38.165l14.143,14.143l37.904-37.904
				c26.002,30.081,42.491,68.599,44.752,110.833H380v20h49.728C427.489,297.353,411.053,337.05,382.708,368.565z"
            />
            <path d="M255,135h-20v115c0,2.652,1.054,5.195,2.929,7.071l75,75l14.143-14.143L255,245.857V135z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default PlanningIcon;
